import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=13a90199&scoped=true&"
import script from "./InputMoney.vue?vue&type=script&lang=js&"
export * from "./InputMoney.vue?vue&type=script&lang=js&"
import style0 from "./InputMoney.vue?vue&type=style&index=0&id=13a90199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a90199",
  null
  
)

export default component.exports